import { useState } from "react";

export const useDiscount = (initialValue: number, subtotal: number, setIsEditing: (val: boolean) => void) => {
  const [discount, setDiscount] = useState<number>(initialValue);

  const handleChange = (value: number) => {
    setIsEditing(true);
    if (value < 0) value = 0;
    else if (value > subtotal) value = subtotal;
    setDiscount(value);
  };

  const handleBlur = () => {
    setIsEditing(false);
    if (discount < 0) setDiscount(0);
    else if (discount > subtotal) setDiscount(subtotal);
  };

  return { discount, setDiscount, handleChange, handleBlur };
};
